import { UserAvatar, UserMenu as BaseUserMenu } from '@zageno/ui';
import type { UserMenuProps as BaseUserMenuProps } from '@zageno/ui';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../hooks';
import { selectUsername, selectIsManageOrg } from '../../features/userSlice';

type UserMenuProps = Pick<BaseUserMenuProps, 'logoutUrl'>;

export default function UserMenu({ logoutUrl }: UserMenuProps) {
  const { t } = useTranslation();

  const defaultItems = [
    {
      label: t('My Account'),
      link: '/accounts/settings',
    },
  ];

  const menuItemsWithOrg = [
    {
      label: t('My Account'),
      link: '/accounts/settings',
    },
    {
      label: t('My Organization'),
      link: '/my-org/dashboard',
    },
  ];

  const userName = useAppSelector(selectUsername);
  const isManageOrg = useAppSelector(selectIsManageOrg);

  return (
    <BaseUserMenu logoutUrl={logoutUrl} menuItems={isManageOrg ? menuItemsWithOrg : defaultItems} userName={userName}>
      <UserAvatar userName={userName} sx={{ display: { xs: 'none', md: 'inline-flex' } }} />
    </BaseUserMenu>
  );
}
